webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CELL_WIDTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CELL_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MINI_CELL_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CELL_SPACING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CELL_RADIUS; });
/* unused harmony export X_OFFSET */
/* unused harmony export Y_OFFSET */
/* unused harmony export xCoord */
/* harmony export (immutable) */ __webpack_exports__["e"] = yCoord;
/* harmony export (immutable) */ __webpack_exports__["c"] = xColCoord;
/* harmony export (immutable) */ __webpack_exports__["d"] = yColCoord;
/* harmony export (immutable) */ __webpack_exports__["b"] = gridHeight;
/* harmony export (immutable) */ __webpack_exports__["a"] = gridWidth;


var CELL_SIZE = 40;

var CELL_WIDTH = CELL_SIZE;
var CELL_HEIGHT = CELL_SIZE;

var MINI_CELL_HEIGHT = CELL_HEIGHT / 2;

var CELL_SPACING = 5;
var CELL_RADIUS = 5;
var X_OFFSET = 20;
var Y_OFFSET = 20;

function xCoord() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      xOffset = _ref.xOffset,
      cellWidth = _ref.cellWidth,
      cellSpacing = _ref.cellSpacing;

  return xOffset + index * (cellWidth + cellSpacing);
}

function yCoord() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var _ref2 = arguments[1];
  var yOffset = _ref2.yOffset,
      cellHeight = _ref2.cellHeight,
      cellSpacing = _ref2.cellSpacing;

  return yOffset + index * (cellHeight + cellSpacing);
}

function xColCoord(index) {
  return xCoord(index, { xOffset: X_OFFSET, cellWidth: CELL_WIDTH, cellSpacing: CELL_SPACING });
}
function yColCoord() {
  return Y_OFFSET;
}

function gridHeight(harmonica) {
  return (harmonica.maxBlowbends() + harmonica.maxDrawbends() + 2) * (CELL_HEIGHT + CELL_SPACING) + 1 * MINI_CELL_HEIGHT + 2 * Y_OFFSET;
}

function gridWidth(harmonica) {
  return harmonica.holes.length * CELL_WIDTH + (harmonica.holes.length - 1) * CELL_SPACING + 2 * X_OFFSET;
}

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initStore", function() { return initStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeSelectedKey", function() { return changeSelectedKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeTuning", function() { return changeTuning; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_alteredstates__ = __webpack_require__(41);


var initStore = function initStore(_ref) {
  var commit = _ref.commit;

  __WEBPACK_IMPORTED_MODULE_0__api_alteredstates__["a" /* getAllTunings */](function (tunings) {
    commit('initStore', tunings);
  });
};

var changeSelectedKey = function changeSelectedKey(_ref2, key) {
  var commit = _ref2.commit;

  commit('changeSelectedKey', key);
};

var changeTuning = function changeTuning(_ref3, tuning) {
  var commit = _ref3.commit;

  commit('changeTuning', tuning);
};

/***/ }),
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HarmonicaHole; });
/* harmony export (immutable) */ __webpack_exports__["a"] = fromPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);




function overblowsFrom(blow, draw) {
  if (blow > draw) {
    return null;
  }
  return [draw + 1];
}

function overdrawsFrom(blow, draw) {
  if (draw > blow) {
    return null;
  }
  return [blow + 1];
}

function drawbendsFrom(blow, draw) {
  if (blow > draw) {
    return null;
  }
  var length = draw - blow - 1;
  return [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(Array(length).keys())).map(function (x) {
    return draw - x - 1;
  });
}

function blowbendsFrom(blow, draw) {
  if (draw > blow) {
    return null;
  }
  var length = blow - draw - 1;
  return [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(Array(length).keys())).map(function (x) {
    return blow - x - 1;
  });
}

var HarmonicaHole = function () {
  function HarmonicaHole(blow, draw) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, HarmonicaHole);

    this.blow = blow;
    this.draw = draw;
    this.overblows = overblowsFrom(blow, draw);
    this.overdraws = overdrawsFrom(blow, draw);
    this.naturalBlowBends = blowbendsFrom(blow, draw);
    this.naturalDrawBends = drawbendsFrom(blow, draw);
    this.blowBends = this.naturalBlowBends || this.overblows;
    this.drawBends = this.naturalDrawBends || this.overdraws;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(HarmonicaHole, [{
    key: "hasOverblows",
    value: function hasOverblows() {
      return this.overblows && this.overblows > 0;
    }
  }, {
    key: "hasOverdraws",
    value: function hasOverdraws() {
      return this.overdraws && this.overdraws > 0;
    }
  }, {
    key: "maxBlowbends",
    value: function maxBlowbends() {
      var note = this;
      var nbOverblows = note.overblows ? note.overblows.length : 0;
      var nbblowbends = note.naturalBlowBends ? note.naturalBlowBends.length : 0;
      return Math.max(nbOverblows, nbblowbends);
    }
  }, {
    key: "maxDrawbends",
    value: function maxDrawbends() {
      var note = this;
      var nbOverdraws = note.overdraws ? note.overdraws.length : 0;
      var nbDrawbends = note.naturalDrawBends ? note.naturalDrawBends.length : 0;
      return Math.max(nbOverdraws, nbDrawbends);
    }
  }]);

  return HarmonicaHole;
}();

function fromPattern(pattern, harpKey) {
  if (!pattern) {
    return { holes: [] };
  }
  var size = pattern.blow.length;
  var holes = [];
  for (var i = 0; i < size; i++) {
    holes.push(new HarmonicaHole(pattern.blow[i] + harpKey, pattern.draw[i] + harpKey));
  }
  return {
    holes: holes,
    maxBlowbends: function maxBlowbends() {
      return this.holes.map(function (x) {
        return x.maxBlowbends();
      }).reduce(function (a, b) {
        return Math.max(a, b);
      }, 0);
    },
    maxDrawbends: function maxDrawbends() {
      return this.holes.map(function (x) {
        return x.maxDrawbends();
      }).reduce(function (a, b) {
        return Math.max(a, b);
      }, 0);
    }
  };
}

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SCALE; });
/* unused harmony export findNote */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getShortName; });
/* unused harmony export getEnglishName */
/* unused harmony export getGermanName */
/* unused harmony export getFrequency */

var SCALE = [{ pitch: 1, short: 'A0', english: 'A0', german: ',,A', frequency: 27.5000 }, { pitch: 2, short: 'Bb0', english: 'A#0/Bb0', german: ',,Ais/,,B', frequency: 29.1353 }, { pitch: 3, short: 'B0', english: 'B0', german: ',,H', frequency: 30.8677 }, { pitch: 4, short: 'C1', english: 'C1', german: ',C', frequency: 32.7032 }, { pitch: 5, short: 'C#1', english: 'C#1/Db1', german: ',Cis/,Des', frequency: 34.6479 }, { pitch: 6, short: 'D1', english: 'D1', german: ',D', frequency: 36.7081 }, { pitch: 7, short: 'Eb1', english: 'D#1/Eb1', german: ',Dis/,Es', frequency: 38.8909 }, { pitch: 8, short: 'E1', english: 'E1', german: ',E', frequency: 41.2035 }, { pitch: 9, short: 'F1', english: 'F1', german: ',F', frequency: 43.6536 }, { pitch: 10, short: 'F#1', english: 'F#1/Gb1', german: ',Fis/,Ges', frequency: 46.2493 }, { pitch: 11, short: 'G1', english: 'G1', german: ',G', frequency: 48.9995 }, { pitch: 12, short: 'G#1', english: 'G#1/Ab1', german: ',Gis/,As', frequency: 51.9130 }, { pitch: 13, short: 'A1', english: 'A1', german: ',A', frequency: 55.0000 }, { pitch: 14, short: 'Bb1', english: 'A#1/Bb1', german: ',Ais/,B', frequency: 58.2705 }, { pitch: 15, short: 'B1', english: 'B1', german: ',H', frequency: 61.7354 }, { pitch: 16, short: 'C2', english: 'C2', german: 'C', frequency: 65.4064 }, { pitch: 17, short: 'C#2', english: 'C#2/Db2', german: 'Cis/Des', frequency: 69.2957 }, { pitch: 18, short: 'D2', english: 'D2', german: 'D', frequency: 73.4162 }, { pitch: 19, short: 'Eb2', english: 'D#2/Eb2', german: 'Dis/Es', frequency: 77.7817 }, { pitch: 20, short: 'E2', english: 'E2', german: 'E', frequency: 82.4069 }, { pitch: 21, short: 'F2', english: 'F2', german: 'F', frequency: 87.3071 }, { pitch: 22, short: 'F#2', english: 'F#2/Gb2', german: 'Fis/Ges', frequency: 92.4986 }, { pitch: 23, short: 'G2', english: 'G2', german: 'G', frequency: 97.9989 }, { pitch: 24, short: 'G#2', english: '#2/Ab2', german: 'Gis/As', frequency: 103.826 }, { pitch: 25, short: 'A2', english: 'A2', german: 'A', frequency: 110.000 }, { pitch: 26, short: 'Bb2', english: 'A#2/Bb2', german: 'Ais/B', frequency: 116.541 }, { pitch: 27, short: 'B2', english: 'B2', german: 'H', frequency: 123.471 }, { pitch: 28, short: 'C3', english: 'C3', german: 'c', frequency: 130.813 }, { pitch: 29, short: 'C#3', english: 'C#3/Db3', german: 'cis/des', frequency: 138.591 }, { pitch: 30, short: 'D3', english: 'D3', german: 'd', frequency: 146.832 }, { pitch: 31, short: 'Eb3', english: 'D#3/Eb3', german: 'dis/es', frequency: 155.563 }, { pitch: 32, short: 'E3', english: 'E3', german: 'e', frequency: 164.814 }, { pitch: 33, short: 'F3', english: 'F3', german: 'f', frequency: 174.614 }, { pitch: 34, short: 'F#3', english: 'F#3/Gb3', german: 'fis/ges', frequency: 184.997 }, { pitch: 35, short: 'G3', english: 'G3', german: 'g', frequency: 195.998 }, { pitch: 36, short: 'G#3', english: 'G#3/Ab3', german: 'gis/as', frequency: 207.652 }, { pitch: 37, short: 'A3', english: 'A3', german: 'a', frequency: 220.000 }, { pitch: 38, short: 'Bb3', english: 'A#3/Bb3', german: 'ais/b', frequency: 233.082 }, { pitch: 39, short: 'B3', english: 'B3', german: 'h', frequency: 246.942 }, { pitch: 40, short: 'C4', english: 'C4', german: 'c’', frequency: 261.626 }, { pitch: 41, short: 'C#4', english: 'C#4/Db4', german: 'cis’/des’', frequency: 277.183 }, { pitch: 42, short: 'D4', english: 'D4', german: 'd’', frequency: 293.665 }, { pitch: 43, short: 'Eb4', english: 'D#4/Eb4', german: 'dis’/es’', frequency: 311.127 }, { pitch: 44, short: 'E4', english: 'E4', german: 'e’', frequency: 329.628 }, { pitch: 45, short: 'F4', english: 'F4', german: 'f’', frequency: 349.228 }, { pitch: 46, short: 'F#4', english: 'F#4/Gb4', german: 'fis’/ges’', frequency: 369.994 }, { pitch: 47, short: 'G4', english: 'G4', german: 'g’', frequency: 391.995 }, { pitch: 48, short: 'G#4', english: 'G#4/Ab4', german: 'gis’/as’', frequency: 415.305 }, { pitch: 49, short: 'A4', english: 'A4', german: 'a’', frequency: 440.000 }, { pitch: 50, short: 'Bb4', english: 'A#4/Bb4', german: 'ais’/b’', frequency: 466.164 }, { pitch: 51, short: 'B4', english: 'B4', german: 'h’', frequency: 493.883 }, { pitch: 52, short: 'C5', english: 'C5', german: 'c’’', frequency: 523.251 }, { pitch: 53, short: 'C#5', english: 'C#5/Db5', german: 'cis’’/des’’', frequency: 554.365 }, { pitch: 54, short: 'D5', english: 'D5', german: 'd’’', frequency: 587.330 }, { pitch: 55, short: 'Eb5', english: 'D#5/Eb5', german: 'dis’’/es’’', frequency: 622.254 }, { pitch: 56, short: 'E5', english: 'E5', german: 'e’’', frequency: 659.255 }, { pitch: 57, short: 'F5', english: 'F5', german: 'f’’', frequency: 698.456 }, { pitch: 58, short: 'F#5', english: 'F#5/Gb5', german: 'fis’’/ges’’', frequency: 739.989 }, { pitch: 59, short: 'G5', english: 'G5', german: 'g’’', frequency: 783.991 }, { pitch: 60, short: 'G#5', english: 'G#5/Ab5', german: 'gis’’/as’’', frequency: 830.609 }, { pitch: 61, short: 'A5', english: 'A5', german: 'a’’', frequency: 880.000 }, { pitch: 62, short: 'Bb5', english: 'A#5/Bb5', german: 'ais’’/b’’', frequency: 932.328 }, { pitch: 63, short: 'B5', english: 'B5', german: 'h’’', frequency: 987.767 }, { pitch: 64, short: 'C6', english: 'C6', german: 'c’’’', frequency: 1046.50 }, { pitch: 65, short: 'C#6', english: 'C#6/Db6', german: 'cis’’’/des’’’', frequency: 1108.73 }, { pitch: 66, short: 'D6', english: 'D6', german: 'd’’’', frequency: 1174.66 }, { pitch: 67, short: 'Eb6', english: 'D#6/Eb6', german: 'dis’’’/es’’’', frequency: 1244.51 }, { pitch: 68, short: 'E6', english: 'E6', german: 'e’’’', frequency: 1318.51 }, { pitch: 69, short: 'F6', english: 'F6', german: 'f’’’', frequency: 1396.91 }, { pitch: 70, short: 'F#6', english: 'F#6/Gb6', german: 'fis’’’/ges’’’', frequency: 1479.98 }, { pitch: 71, short: 'G6', english: 'G6', german: 'g’’’', frequency: 1567.98 }, { pitch: 72, short: 'G#6', english: 'G#6/Ab6', german: 'gis’’’/as’’’', frequency: 1661.22 }, { pitch: 73, short: 'A6', english: 'A6', german: 'a’’’', frequency: 1760.00 }, { pitch: 74, short: 'Bb6', english: 'A#6/Bb6', german: 'ais’’’/b’’’', frequency: 1864.66 }, { pitch: 75, short: 'B6', english: 'B6', german: 'h’’’', frequency: 1975.53 }, { pitch: 76, short: 'C7', english: 'C7', german: 'c’’’’', frequency: 2093.00 }, { pitch: 77, short: 'C#7', english: 'C#7/Db7', german: 'cis’’’’/des’’’’', frequency: 2217.46 }, { pitch: 78, short: 'D7', english: 'D7', german: 'd’’’’', frequency: 2349.32 }, { pitch: 79, short: 'Eb7', english: 'D#7/Eb7', german: 'dis’’’’/es’’’’', frequency: 2489.02 }, { pitch: 80, short: 'E7', english: 'E7', german: 'e’’’’', frequency: 2637.02 }, { pitch: 81, short: 'F7', english: 'F7', german: 'f’’’’', frequency: 2793.83 }, { pitch: 82, short: 'F#7', english: 'F#7/Gb7', german: 'fis’’’’/ges’’’’', frequency: 2959.96 }, { pitch: 83, short: 'G7', english: 'G7', german: 'g’’’’', frequency: 3135.96 }, { pitch: 84, short: 'Ab7', english: 'G#7/Ab7', german: 'gis’’’’/as’’’’', frequency: 3322.44 }, { pitch: 85, short: 'A7', english: 'A7', german: 'a’’’’', frequency: 3520.00 }, { pitch: 86, short: 'Bb7', english: 'A#7/Bb7', german: 'ais’’’’/b’’’’', frequency: 3729.31 }, { pitch: 87, short: 'B7', english: 'B7', german: 'h’’’’', frequency: 3951.07 }, { pitch: 88, short: 'C8', english: 'C8', german: 'c’’’’’', frequency: 4186.01 }];

var findNote = function findNote(pitch) {
  return SCALE.find(function (note) {
    return note.pitch === pitch;
  });
};

var getShortName = function getShortName(pitch) {
  return findNote(pitch).short;
};
var getEnglishName = function getEnglishName(pitch) {
  return findNote(pitch).english;
};
var getGermanName = function getGermanName(pitch) {
  return findNote(pitch).german;
};
var getFrequency = function getFrequency(pitch) {
  return findNote(pitch).frequency;
};

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(43);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  state: {
    catalogue: null,
    currentHarmonica: null,
    selectedKey: 40
  },
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__,
  getters: {},
  modules: {}
});
/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 37 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 38 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(88)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(98),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 40 */,
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAllTunings;
var _catalogue = [{
  name: 'Richter',
  blow: [0, 4, 7, 12, 16, 19, 24, 28, 31, 36],
  draw: [2, 7, 11, 14, 17, 21, 23, 26, 29, 33],
  comment: ''
}, {
  name: 'Country',
  blow: [0, 4, 7, 12, 16, 19, 24, 28, 31, 36],
  draw: [2, 7, 11, 14, 18, 21, 23, 26, 29, 33],
  comment: 'aka Lydian, aka Major 7th'
}, {
  name: 'Paddy richter',
  blow: [0, 4, 9, 12, 16, 19, 24, 28, 31, 36],
  draw: [2, 7, 11, 14, 17, 21, 23, 26, 29, 33],
  comment: '[Developed by Brendan Power](http://www.brendan-power.com/harmonicas-10hole.php)'
}, {
  name: 'Melodic Maker',
  blow: [-7, -3, 2, 5, 9, 12, 17, 21, 24, 29],
  draw: [-5, 0, 4, 7, 11, 14, 16, 19, 23, 26],
  comment: ''
}, {
  name: 'Natural minor',
  blow: [0, 3, 7, 12, 15, 19, 24, 27, 31, 36],
  draw: [2, 7, 10, 14, 17, 21, 22, 26, 29, 33],
  comment: ''
}, {
  name: 'Harmonic minor',
  blow: [0, 3, 7, 12, 15, 19, 24, 27, 31, 36],
  draw: [2, 7, 11, 14, 17, 20, 23, 26, 29, 32],
  comment: ''
}, {
  name: 'Circular',
  blow: [0, 4, 7, 10, 14, 17, 21, 24, 28, 31],
  draw: [2, 5, 9, 12, 16, 19, 22, 26, 29, 33],
  comment: ''
}, {
  name: 'Solo',
  blow: [0, 4, 7, 12, 12, 16, 19, 24, 24, 28, 31, 36],
  draw: [2, 5, 9, 11, 14, 17, 21, 23, 26, 29, 33, 35],
  comment: ''
}, {
  name: 'Lucky 13',
  blow: [-12, -8, -5, 0, 4, 7, 12, 16, 19, 24, 28, 31, 36],
  draw: [-10, -5, -1, 2, 7, 11, 14, 17, 21, 23, 26, 29, 33],
  comment: '[Developed by Brendan Power](http://www.brendan-power.com/lucky13.php)'
}, {
  name: 'Orchestra',
  blow: [7, 12, 12, 16, 19, 24, 24, 28, 31, 36],
  draw: [9, 11, 14, 17, 21, 23, 26, 29, 33, 35],
  comment: ''
}, {
  name: 'PowerBender',
  blow: [0, 4, 7, 12, 14, 17, 21, 24, 28, 33],
  draw: [2, 7, 11, 14, 16, 19, 23, 26, 31, 36],
  comment: '[Developed by Brendan Power](http://www.brendan-power.com/harmonicas-10hole.php)'
}, {
  name: 'PowerDraw',
  blow: [0, 4, 7, 12, 16, 19, 21, 24, 28, 33],
  draw: [2, 7, 11, 14, 17, 21, 23, 26, 31, 36],
  comment: '[Developed by Brendan Power](http://www.brendan-power.com/harmonicas-10hole.php)'
}, {
  name: 'Wholetone',
  blow: [0, 4, 8, 12, 16, 20, 24, 28, 32, 36],
  draw: [2, 6, 10, 14, 18, 22, 26, 30, 34, 38],
  comment: 'See [Some Musings On Altered Tunings For the Chromatic Harmonica](http://www.angelfire.com/music/HarpOn/patsmusings.html)'
}, {
  name: 'Diminished',
  blow: [0, 3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33],
  draw: [2, 5, 8, 11, 14, 17, 20, 23, 26, 29, 32, 35],
  comment: 'See [Some Musings On Altered Tunings For the Chromatic Harmonica](http://www.angelfire.com/music/HarpOn/patsmusings.html)'
}, {
  name: 'Augmented',
  blow: [0, 4, 8, 12, 16, 20, 24, 28, 32, 36],
  draw: [3, 7, 11, 15, 19, 23, 27, 31, 35, 39],
  comment: 'See [Some Musings On Altered Tunings For the Chromatic Harmonica](http://www.angelfire.com/music/HarpOn/patsmusings.html)'
}];

function getAllTunings(cb) {
  return cb(_catalogue);
}

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_design_icons_iconfont_material_icons_css__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_design_icons_iconfont_material_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_design_icons_iconfont_material_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_actions__ = __webpack_require__(19);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__store_actions__["initStore"])(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_4__App___default.a);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeSelectedKey", function() { return changeSelectedKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeTuning", function() { return changeTuning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initStore", function() { return initStore; });
var changeSelectedKey = function changeSelectedKey(state, newKey) {
  state.selectedKey = newKey;
};

var changeTuning = function changeTuning(state, tuning) {
  state.currentHarmonica = tuning;
};

var initStore = function initStore(state, tunings) {
  state.catalogue = tunings;
  changeTuning(state, tunings[0]);
};

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HarmapGrid__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HarmapGrid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_HarmapGrid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__solfege__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_marked__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_marked__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',

  components: { HarmapGrid: __WEBPACK_IMPORTED_MODULE_1__components_HarmapGrid___default.a },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    localTuning: {
      get: function get() {
        return this.currentHarmonica;
      },
      set: function set(value) {
        this.changeTuning(value);
      }
    },
    localKey: {
      get: function get() {
        return this.selectedKey;
      },
      set: function set(value) {
        this.changeSelectedKey(value);
      }
    },
    possibleKeys: function possibleKeys() {
      return __WEBPACK_IMPORTED_MODULE_2__solfege__["a" /* SCALE */].filter(function (x) {
        return x.pitch > 20;
      }).filter(function (x) {
        return x.pitch < 49;
      });
    },
    comment: function comment() {
      return __WEBPACK_IMPORTED_MODULE_4_marked___default()(this.localTuning.comment);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])(['catalogue', 'currentHarmonica', 'selectedKey'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    getShortName: __WEBPACK_IMPORTED_MODULE_2__solfege__["b" /* getShortName */]

  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['changeSelectedKey', 'changeTuning']))
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__solfege__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__grid__ = __webpack_require__(6);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'harmap-cell',

  props: ['x', 'y', 'pitch', 'type'],

  data: function data() {
    return {
      cellWidth: __WEBPACK_IMPORTED_MODULE_1__grid__["i" /* CELL_WIDTH */],
      cellHeight: __WEBPACK_IMPORTED_MODULE_1__grid__["f" /* CELL_HEIGHT */],
      cellRadius: __WEBPACK_IMPORTED_MODULE_1__grid__["j" /* CELL_RADIUS */],
      classRect: {
        '-over': this.type === 'over',
        '-trad': this.type === 'trad',
        '-natural': this.type === 'natural'
      }
    };
  },


  methods: {
    consoleLog: function consoleLog(log) {
      console.log(log);
    }
  },

  computed: {
    name: function name() {
      return this.pitch ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__solfege__["b" /* getShortName */])(this.pitch) : '';
    },
    txtDx: function txtDx() {
      return this.cellWidth / 2;
    },
    txtDy: function txtDy() {
      return this.cellHeight / 2;
    },
    isOverblow: function isOverblow() {
      return this.type === 'over';
    },
    isTrad: function isTrad() {
      return this.type === 'trad';
    }
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HarmapCell__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HarmapCell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__HarmapCell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HarmapHoleNumber__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HarmapHoleNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__HarmapHoleNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__grid__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__harmonica__ = __webpack_require__(21);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'harmap-col',

  props: {
    hole: {
      type: __WEBPACK_IMPORTED_MODULE_3__harmonica__["b" /* HarmonicaHole */],
      required: true
    },
    holeNumber: { type: Number, required: true },

    x: { type: Number, required: true },

    y: { type: Number, required: true },

    maxBlow: { type: Number, required: true },

    maxDraw: { type: Number, required: true }
  },

  components: { HarmapCell: __WEBPACK_IMPORTED_MODULE_0__HarmapCell___default.a, HarmapHoleNumber: __WEBPACK_IMPORTED_MODULE_1__HarmapHoleNumber___default.a },

  computed: {
    blownote: function blownote() {
      return this.hole.blow;
    },
    drawnote: function drawnote() {
      return this.hole.draw;
    },
    blowbends: function blowbends() {
      var blowBends = this.hole.blowBends;
      var finalBlowBends = [];
      for (var i = 0; i < this.maxBlow; i++) {
        var note = {
          pitch: i <= blowBends.length ? blowBends[i] : null,
          type: this.hole.hasOverblows() ? 'over' : 'trad',
          direction: 'blow'
        };
        finalBlowBends.push(note);
      }
      finalBlowBends.reverse();
      return finalBlowBends;
    },
    drawbends: function drawbends() {
      var drawBends = this.hole.drawBends;
      var finalDrawBends = [];
      for (var i = 0; i < this.maxDraw; i++) {
        var note = {
          pitch: i <= drawBends.length ? drawBends[i] : null,
          type: this.hole.hasOverdraws() ? 'over' : 'trad',
          direction: 'draw'
        };
        finalDrawBends.push(note);
      }
      return finalDrawBends;
    }
  },

  methods: {
    xCoord: function xCoord() {
      return this.x;
    },
    yCoordBlowbend: function yCoordBlowbend(index) {
      var yOffset = this.y;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__grid__["e" /* yCoord */])(index, { yOffset: yOffset, cellHeight: __WEBPACK_IMPORTED_MODULE_2__grid__["f" /* CELL_HEIGHT */], cellSpacing: __WEBPACK_IMPORTED_MODULE_2__grid__["g" /* CELL_SPACING */] });
    },
    yCoordBlownote: function yCoordBlownote() {
      var yOffset = this.yCoordBlowbend(this.maxBlow);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__grid__["e" /* yCoord */])(0, { yOffset: yOffset, cellHeight: __WEBPACK_IMPORTED_MODULE_2__grid__["f" /* CELL_HEIGHT */], cellSpacing: __WEBPACK_IMPORTED_MODULE_2__grid__["g" /* CELL_SPACING */] });
    },
    yCoordHolenumber: function yCoordHolenumber() {
      var yOffset = this.yCoordBlowbend(this.maxBlow) + __WEBPACK_IMPORTED_MODULE_2__grid__["f" /* CELL_HEIGHT */] + __WEBPACK_IMPORTED_MODULE_2__grid__["g" /* CELL_SPACING */];
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__grid__["e" /* yCoord */])(0, { yOffset: yOffset, cellHeight: __WEBPACK_IMPORTED_MODULE_2__grid__["f" /* CELL_HEIGHT */], cellSpacing: __WEBPACK_IMPORTED_MODULE_2__grid__["g" /* CELL_SPACING */] });
    },
    yCoordDrawnote: function yCoordDrawnote() {
      var yOffset = this.yCoordHolenumber() + __WEBPACK_IMPORTED_MODULE_2__grid__["h" /* MINI_CELL_HEIGHT */] + __WEBPACK_IMPORTED_MODULE_2__grid__["g" /* CELL_SPACING */];
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__grid__["e" /* yCoord */])(0, { yOffset: yOffset, cellHeight: __WEBPACK_IMPORTED_MODULE_2__grid__["f" /* CELL_HEIGHT */], cellSpacing: __WEBPACK_IMPORTED_MODULE_2__grid__["g" /* CELL_SPACING */] });
    },
    yCoordDrawbend: function yCoordDrawbend(index) {
      var yOffset = this.yCoordDrawnote() + __WEBPACK_IMPORTED_MODULE_2__grid__["f" /* CELL_HEIGHT */] + __WEBPACK_IMPORTED_MODULE_2__grid__["g" /* CELL_SPACING */];
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__grid__["e" /* yCoord */])(index, { yOffset: yOffset, cellHeight: __WEBPACK_IMPORTED_MODULE_2__grid__["f" /* CELL_HEIGHT */], cellSpacing: __WEBPACK_IMPORTED_MODULE_2__grid__["g" /* CELL_SPACING */] });
    }
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HarmapCol__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HarmapCol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__HarmapCol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__grid__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__harmonica__ = __webpack_require__(21);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'harmap-grid',

  props: ['pattern', 'harpKey'],

  components: { HarmapCol: __WEBPACK_IMPORTED_MODULE_0__HarmapCol___default.a },

  mounted: function mounted() {
    window.addEventListener('resize', this.handleResize);
  },

  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

  data: function data() {
    return {
      landscape: window.innerHeight > window.innerWidth
    };
  },


  computed: {
    width: function width() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__grid__["a" /* gridWidth */])(this.harmo);
    },
    height: function height() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__grid__["b" /* gridHeight */])(this.harmo);
    },
    harmo: function harmo() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__harmonica__["a" /* fromPattern */])(this.pattern, this.harpKey);
    },
    holes: function holes() {
      return this.harmo.holes;
    },
    maxblow: function maxblow() {
      return this.harmo.maxBlowbends();
    },
    maxdraw: function maxdraw() {
      return this.harmo.maxDrawbends();
    },
    viewBox: function viewBox() {
      return [0, 0, this.width, this.height].join(' ');
    },
    innerHeight: function innerHeight() {
      return window.innerHeight;
    },
    innerWidth: function innerWidth() {
      return window.innerWidth;
    }
  },

  methods: {
    xColCoord: __WEBPACK_IMPORTED_MODULE_1__grid__["c" /* xColCoord */],
    yColCoord: __WEBPACK_IMPORTED_MODULE_1__grid__["d" /* yColCoord */],
    handleResize: function handleResize(event) {
      this.landscape = event.currentTarget.innerHeight > event.currentTarget.innerWidth;
    }
  }
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__grid__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'harmap-hole-number',

  props: ['x', 'y', 'text'],

  data: function data() {
    return {
      cellWidth: __WEBPACK_IMPORTED_MODULE_0__grid__["i" /* CELL_WIDTH */],
      cellHeight: __WEBPACK_IMPORTED_MODULE_0__grid__["h" /* MINI_CELL_HEIGHT */],
      cellRadius: __WEBPACK_IMPORTED_MODULE_0__grid__["j" /* CELL_RADIUS */]
    };
  },


  computed: {
    txtDx: function txtDx() {
      return this.cellWidth / 2;
    },
    txtDy: function txtDy() {
      return this.cellHeight / 2;
    }
  }
});

/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 88 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */,
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(89)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(99),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-51836015",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(90)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(100),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-76af3f9d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(91)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(101),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c9ac600e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(87)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(97),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0274c71c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', [_c('rect', {
    staticClass: "border",
    attrs: {
      "x": _vm.x,
      "y": _vm.y,
      "rx": _vm.cellRadius,
      "width": _vm.cellWidth,
      "height": _vm.cellHeight
    }
  }), _vm._v(" "), _c('text', {
    staticClass: "text",
    attrs: {
      "x": _vm.x,
      "y": _vm.y,
      "dx": _vm.txtDx,
      "dy": _vm.txtDy
    }
  }, [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('v-app', [_c('v-navigation-drawer'), _vm._v(" "), _c('v-toolbar', [_c('v-toolbar-title', [_vm._v("Harmap")])], 1), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs10": "",
      "hidden-md-and-up": ""
    }
  }, [(_vm.localTuning) ? _c('v-select', {
    attrs: {
      "items": _vm.catalogue,
      "item-text": "name"
    },
    model: {
      value: (_vm.localTuning),
      callback: function($$v) {
        _vm.localTuning = $$v
      },
      expression: "localTuning"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "hidden-md-and-up": ""
    }
  }, [(_vm.localKey) ? _c('v-select', {
    attrs: {
      "items": _vm.possibleKeys,
      "item-text": "short",
      "item-value": "pitch"
    },
    model: {
      value: (_vm.localKey),
      callback: function($$v) {
        _vm.localKey = $$v
      },
      expression: "localKey"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md2": "",
      "hidden-sm-and-down": ""
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.catalogue), function(tuning) {
    return _c('v-list-item', {
      key: tuning,
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.localTuning = tuning
        }
      }
    }, [_c('v-list-tile', {
      attrs: {
        "avatar": ""
      }
    }, [_c('v-list-tile-action', [(_vm.localTuning === tuning) ? _c('v-icon', {
      staticClass: "pink--text"
    }, [_vm._v("star")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(tuning.name)
      }
    })], 1)], 1)], 1)
  }))], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md2": "",
      "hidden-sm-and-down": ""
    }
  }, [_c('v-list', {
    staticClass: "localKey",
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.possibleKeys), function(k) {
    return _c('v-list-item', {
      key: k.pitch,
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.localKey = k.pitch
        }
      }
    }, [_c('v-list-tile', {
      attrs: {
        "avatar": ""
      }
    }, [_c('v-list-tile-action', [(_vm.localKey === k.pitch) ? _c('v-icon', {
      staticClass: "pink--text"
    }, [_vm._v("star")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(k.short)
      }
    })], 1)], 1)], 1)
  }))], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md10": "",
      "xs12": ""
    }
  }, [_c('harmap-grid', {
    attrs: {
      "pattern": _vm.localTuning,
      "harp-key": _vm.selectedKey
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.comment)
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-footer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', [(_vm.name) ? _c('rect', {
    staticClass: "border",
    class: _vm.classRect,
    attrs: {
      "x": _vm.x,
      "y": _vm.y,
      "rx": _vm.cellRadius,
      "width": _vm.cellWidth,
      "height": _vm.cellHeight
    },
    on: {
      "click": function($event) {
        _vm.consoleLog(_vm.name)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('text', {
    staticClass: "name",
    attrs: {
      "x": _vm.x,
      "y": _vm.y,
      "dx": _vm.txtDx,
      "dy": _vm.txtDy
    }
  }, [_vm._v(_vm._s(_vm.name))])])
},staticRenderFns: []}

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', [_vm._l((_vm.blowbends), function(note, index) {
    return (note && note.pitch) ? [_c('harmap-cell', {
      key: note,
      attrs: {
        "x": _vm.xCoord(),
        "y": _vm.yCoordBlowbend(index),
        "pitch": note.pitch,
        "type": note.type
      }
    })] : _vm._e()
  }), _vm._v(" "), _c('harmap-cell', {
    attrs: {
      "x": _vm.xCoord(),
      "y": _vm.yCoordBlownote(),
      "pitch": _vm.blownote,
      "type": "natural"
    }
  }), _vm._v(" "), _c('harmap-hole-number', {
    attrs: {
      "x": _vm.xCoord(),
      "y": _vm.yCoordHolenumber(),
      "text": _vm.holeNumber + 1
    }
  }), _vm._v(" "), _c('harmap-cell', {
    attrs: {
      "x": _vm.xCoord(),
      "y": _vm.yCoordDrawnote(),
      "pitch": _vm.drawnote,
      "type": "natural"
    }
  }), _vm._v(" "), _vm._l((_vm.drawbends), function(note, index) {
    return (note && note.pitch) ? [_c('harmap-cell', {
      key: note,
      attrs: {
        "x": _vm.xCoord(),
        "y": _vm.yCoordDrawbend(index),
        "pitch": note.pitch,
        "type": note.type
      }
    })] : _vm._e()
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('svg', {
    staticClass: "svg-content",
    attrs: {
      "viewBox": _vm.viewBox,
      "preserveAspectRatio": "xMinYMin meet"
    }
  }, [_c('g', [_vm._l((_vm.holes), function(hole, index) {
    return [_c('harmap-col', {
      key: hole,
      attrs: {
        "x": _vm.xColCoord(index),
        "y": _vm.yColCoord(),
        "hole-number": index,
        "max-blow": _vm.maxblow,
        "max-draw": _vm.maxdraw,
        "hole": hole
      }
    })]
  })], 2)])])
},staticRenderFns: []}

/***/ })
],[42]);


// WEBPACK FOOTER //
// static/js/app.606ae6b18b0e5641f5ac.js